export default __webpack_public_path__ + "static/media/Coffee.cb7b0899.png";